<p-toast position="bottom-center"></p-toast>
<p-toast key="quiz-rejected" position="top-center" styleClass="toast-quiz-rejected"></p-toast>
<p-toast key="coupon-success" position="top-center" styleClass="toast-coupon-success">
  <ng-template let-message pTemplate="message">
    <img
      class="toast-coupon-success__icon"
      src="assets/icons/ic_check_circle.svg"
      width="20"
      height="20"
      alt=""
      aria-hidden="true"
    />
    <span class="toast-coupon-success__text t-12-400-dark">{{
      message.summary
    }}</span>
  </ng-template>
</p-toast>
